(function () {
    var postcodeLookups = document.querySelectorAll('[data-postcode-lookup]')

    if (postcodeLookups.length > 0) {
        postcodeLookups.forEach(postcodeLookup => {
            var input = postcodeLookup.querySelector('[data-postcode-lookup-input]')
            var button = postcodeLookup.querySelector('[data-postcode-lookup-button]')
            var results = postcodeLookup.querySelector('[data-postcode-lookup-results]')
            var relatedFields = JSON.parse(postcodeLookup.getAttribute('data-related-fields'))


            button.addEventListener('click', function () {
                results.innerHTML = ''

                if (input.value != '') {
                    let formData = new FormData()
                    formData.append('postcode', input.value)
                    fetch('/scripts/postcode-lookup.php', {
                        method: 'POST',
                        body: formData
                    }).then(res => res.json()).then(data => {
                        if (data.PremiseData != undefined && data.PremiseData.length > 0) {
                            var address1 = data.Address1
                            if (data.Address2 != undefined) {
                                var address2 = data.Address2
                            }
                            var city = data.Town
                            var county = data.County
                            data.PremiseData.forEach(prefix => {
                                var li = document.createElement('li')
                                li.classList.add('autocomplete-list__item')
                                li.dataset.address1 = prefix + ' ' + address1
                                if (address2 != undefined) {
                                    li.dataset.address2 = address2
                                }
                                li.dataset.city = city
                                li.dataset.county = county
                                li.innerHTML = prefix + ' ' + address1 + ', ' + city
                                results.appendChild(li)

                                li.addEventListener('click', function () {
                                    if (this.dataset.address1 != '' && this.dataset.address1 != undefined && relatedFields.address_line_1 != undefined) {
                                        document.getElementById(relatedFields.address_line_1).value = this.dataset.address1.replace('  ', ' ')
                                    } else if (relatedFields.address_line_1 != undefined) {
                                        document.getElementById(relatedFields.address_line_1).value = ''
                                    }
                                    if (this.dataset.address2 != '' && this.dataset.address2 != undefined && relatedFields.address_line_2 != undefined) {
                                        document.getElementById(relatedFields.address_line_2).value = this.dataset.address2
                                    } else if (relatedFields.address_line_2 != undefined) {
                                        document.getElementById(relatedFields.address_line_2).value = ''
                                    }
                                    if (this.dataset.city != '' && this.dataset.city != undefined && relatedFields.city != undefined) {
                                        document.getElementById(relatedFields.city).value = this.dataset.city
                                    } else if (relatedFields.city != undefined) {
                                        document.getElementById(relatedFields.city).value = ''
                                    }
                                    if (relatedFields.country != undefined) {
                                        document.getElementById(relatedFields.country).value = 'United Kingdom'
                                        document.getElementById(relatedFields.country).dispatchEvent(new Event('change'))
                                    }
                                    setTimeout(() => {
                                        if (this.dataset.county != '' && this.dataset.county != undefined && relatedFields.region != undefined) {
                                            var options = document.getElementById(relatedFields.region).options
                                            for (var i = 0; i < options.length; i++) {
                                                if (options[i].value.toLowerCase() == this.dataset.county.toLowerCase()) {
                                                    document.getElementById(relatedFields.region).value = options[i].value
                                                    break
                                                }
                                            }
                                        } else {
                                            document.getElementById(relatedFields.region).value = ''
                                        }
                                    }, 250)
                                    results.parentNode.classList.remove('active')
                                })

                            })
                            results.parentNode.classList.add('active')

                            document.addEventListener('click', function (e) {
                                if (!e.target.classList.contains('autocomplete-list__item') && e.target.id != button.id && e.target.id != input.id) {
                                    results.parentNode.classList.remove('active')
                                }
                            })
                        } else {
                            button.innerHTML = 'No Results'
                            button.classList.add('button--delete')
                            setTimeout(() => {
                                button.innerHTML = 'Find'
                                button.classList.remove('button--delete')
                            }, 3000)
                        }
                    })
                }
            })
        })
    }
    if (document.getElementById('shipping-lookup-postcode')) {
        document.getElementById('shipping-lookup-postcode').addEventListener('click', function () {
            var postcode = document.getElementById('frm_d_postcode').value
            var ul = document.getElementById('shipping-postcode-results')
            ul.parentNode.classList.add('active')
            ul.innerHTML = ''
            if (postcode != '') {
                let formData = new FormData()
                formData.append('postcode', postcode)
                fetch('/scripts/postcode-lookup.php', {
                    method: 'POST',
                    body: formData
                }).then(res => res.json()).then(data => {

                })
            }
        })
    }
})()